import { token } from './token';
import { components } from './components';

export const themeConfig = {
    token,
    components,
};
